import { useRef, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

const HeartIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const EyeIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export default function ProductCard({ product }) {
  const videoRef = useRef(null);
  const [wishlisted, setWishlisted] = useState(false);

  // Hover pe video play/pause
  const handleMouseEnter = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(() => {});
    }
  }, []);

  const handleMouseLeave = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  }, []);

  const handleWishlist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setWishlisted((prev) => !prev);
  };

  // Gallery se pehli image fallback thumbnail
  const displayImage =
    product.image ||
    (product.gallery && product.gallery[0]) ||
    "/placeholder.jpg";

    const navigate = useNavigate();

  return (
    <>
      <article
        className="pcard"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => navigate(`/shop/${product.slug || product.id}`)}
      >
        {/* Media */}
        <div className="pcard-media">
          {/* Badge */}
          {product.badge && (
            <span className="pcard-badge">{product.badge}</span>
          )}

          {/* Image */}
          <img
            className={`pcard-image${product.video ? " has-video" : ""}`}
            src={displayImage}
            alt={product.name}
            loading="lazy"
          />

          {/* Video — only if present */}
          {product.video && (
            <video
              ref={videoRef}
              className="pcard-video"
              muted
              loop
              playsInline
              preload="none"
              aria-hidden="true"
            >
              <source src={product.video} type="video/mp4" />
            </video>
          )}

          {/* Overlay */}
          <div className="pcard-media-overlay" aria-hidden="true" />

          {/* Quick Actions */}
          <div className="pcard-actions">
            <button
              className={`pcard-action-btn${wishlisted ? " wishlisted" : ""}`}
              onClick={handleWishlist}
              aria-label={
                wishlisted ? "Remove from wishlist" : "Add to wishlist"
              }
            >
              <HeartIcon />
            </button>

            <Link
              to={`/shop/${product.slug || product.id}`}
              className="pcard-quick-view"
              aria-label={`Quick view ${product.name}`}
            >
              <EyeIcon />
              Quick View
            </Link>
          </div>
        </div>

        {/* Content */}
        <div className="pcard-content px-3">
          {product.craft && (
            <span className="pcard-craft">{product.craft}</span>
          )}

          <Link
            to={`/shop/${product.slug || product.id}`}
            className="pcard-name"
          >
            {product.name}
          </Link>

          <div className="pcard-price-row">
            <span className="pcard-price">
              ₹{product.price.toLocaleString("en-IN")}
            </span>
            {product.originalPrice && (
              <span className="pcard-price-original">
                ₹{product.originalPrice.toLocaleString("en-IN")}
              </span>
            )}
          </div>
        </div>

        {/* Animated bottom rule */}
        <div className="pcard-rule" aria-hidden="true" />
      </article>
    </>
  );
}
